import styled from "styled-components";
import { HeroBanner, NftBgImg } from "../../shared/icons";
import { screenSizes } from "../../styles/theme";

//NFT Details HeroSection
export const TopSectionNftWrapper = styled.div`
  background: url(${HeroBanner}) no-repeat center center;
  background-size: cover;
  padding: 50px 0;
`;
export const TopSectionContent = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  @media (max-width: ${screenSizes.S}px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
export const SectionContent = styled.div`
  h1 {
    font-weight: 400;
    font-size: calc(2.1vw + 20px);
    color: #fff;
  }
  ul {
    list-style: none;
    padding: 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
    li {
      font-family: "Sora", sans-serif;
      color: #fff;
      font-weight: 500;
      span {
        font-family: "Sora", sans-serif;
        color: #fff;
        font-weight: 500;
        margin-right: 10px;
      }
      img {
        vertical-align: middle;
        margin-right: 10px;
      }
    }
  }
  p {
    color: #fff;
    font-family: "Sora", sans-serif;
    span {
      font-family: "Sora", sans-serif;
      border-radius: 50px;
      border: 1px solid #ff9d59;
      padding: 10px 20px;
      background: #1e440b;
      display: inline-block;
      color: #ff9d59;
      img {
        vertical-align: middle;
        margin-right: 10px;
      }
    }
  }
`;

//NFT Details HeroSection end
export const NftDetailenvironment = styled.div`
  margin-bottom: 80px;
  padding: 80px;
  background: rgba(9, 28, 0, 0.1);
  border-radius: 10px;
  @media (max-width: ${screenSizes.L}px) {
    padding: 1rem;
    background-color: #091C001A;
    margin-bottom: 20px;
  }
  ul {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    @media (max-width: ${screenSizes.L}px) {
      grid-template-columns: repeat(1, 1fr);
    }
    align-items: center;
    list-style: none;
    gap: 50px;
    padding: 0;
    margin: 0;

    li {
      button {
        margin-top: 15px;
      }
      h1 {
        font-size: 50px;
        font-weight: 700;
        line-height: 64px;
        color: #091c00;
        margin-bottom: 20px;
        @media (max-width: ${screenSizes.L}px) {
          font-size: 32px;
          line-height: 40px;
        }
      }
      p {
        font-size: 16px;
        font-weight: 400;
        color: rgba(9, 28, 0, 0.8);
        margin-top: 0;
        line-height: 24px;
        @media (max-width: ${screenSizes.S}px) {
          margin-bottom: 0;
        }
        span {
          position: relative;
          padding-left: 15px;
          &:before {
            content: "";
            position: absolute;
            left: 0;
            top: 5px;
            background: #fff;
            width: 8px;
            height: 8px;
            border-radius: 50px;
          }
        }
      }
      div {
        display: flex;
        column-gap: 20px;
      }
      &:first-child {
      }
      &:last-child {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 40px;
        @media (max-width: ${screenSizes.L}px) {
          gap: 15px;
        }
      }
    }
    p {
      font-family: "Sora", sans-serif;
      span {
        font-family: "Sora", sans-serif;
        position: relative;
        padding-left: 10px;
        &:before {
          content: "";
          position: absolute;
          left: 0;
          top: 7px;
          border-radius: 50px;
          width: 5px;
          height: 5px;
          background: #000;
        }
      }
    }
  }
`;
//middle section styled for nft details page
export const NftDetailMiddleSection = styled.div`
  padding-inline: 4rem;
  padding-bottom: 4rem;
  @media (max-width: ${screenSizes.L}px) {
    padding: 0;
    margin-bottom: 30px;
  }
  ul {
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    list-style: disc;
    gap: 50px;
    padding: 0;
    margin: 0;
    margin-left: 25px;
    li {
      button {
        margin-top: 15px;
      }
      h1 {
        font-size: 50px;
        font-weight: 700;
        color: rgba(9, 28, 0, 1);
        margin-bottom: 20px;
        @media (max-width: ${screenSizes.L}px) {
          font-size: 32px;
        }
      }
      p {
        font-weight: 400;
        color: #1e440b;
        margin-top: 0;
        line-height: 150%;
        span {
          position: relative;
          padding-left: 15px;
          font-family: "Sora", sans-serif;
          &:before {
            content: "";
            position: absolute;
            left: 0;
            top: 5px;
            background: #fff;
            width: 8px;
            height: 8px;
            border-radius: 50px;
          }
        }
      }
    }
    p {
      font-family: "Sora", sans-serif;
      span {
        font-family: "Sora", sans-serif;
        position: relative;
        padding-left: 10px;
        &:before {
          content: "";
          position: absolute;
          left: 0;
          top: 7px;
          border-radius: 50px;
          width: 5px;
          height: 5px;
          background: #000;
        }
      }
    }
  }
`;

export const TreePlantedDiv = styled.div`
  display: flex;
  flex-direction: column;
  p {
    color: rgba(9, 28, 0, 0.8);
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 5px;
  }
  span {
    display: flex;
    align-items: center;
    gap: 10px;
    h4 {
      color: #091c00;
      font-weight: 800;
      font-size: 36px;
    }
  }
`;
//testimonials section styles
export const TestimonialSectionWrapper = styled.div`
  padding: 80px;
  @media (max-width: ${screenSizes.L}px) {
    padding: 1rem;
  }
  padding-top: 0;
  h4 {
    text-align: center;
    font-size: 50px;
    font-weight: 700;
    color: #091c00;
    margin-bottom: 40px;
    letter-spacing: -2px;
    @media (max-width: ${screenSizes.L}px) {
      font-size: 32px;
      line-height: 24px;
      text-align: left;
      letter-spacing: 0;
    }
  }
`;
export const TestimonialCardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  @media (max-width: ${screenSizes.S}px) {
    grid-template-columns: repeat(1, 1fr);
  }
  gap: 24px;
  margin-bottom: 80px;
  @media (max-width: ${screenSizes.L}px) {
    margin-bottom: 20px;
  }
`;
export const TestimonialCards = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px;
  border-radius: 0 0 40px 0;
  border: 1px solid rgba(9, 28, 0, 0.1);
  h4 {
   color: #091C00;
   font-size: 16px;
   font-weight: 700;
    text-align: left;
   margin-block: 15px;
   text-transform: capitalize;
   letter-spacing: 0;
   @media (max-width: ${screenSizes.L}px) {
    margin-bottom: 0px;
  }
  }
  img {
    width: 100%;
  }
  h6 {
    font-size: 14px;
    font-weight: 400;
    color: #091c00;
   margin-block: 0;
   margin-bottom: 35px;
    @media (max-width: ${screenSizes.L}px) {
    margin-block: 15px;
    }
  }
  p {
    font-size: 16px;
    font-weight: 400;
    color: #091c00;
  }
`;
//testimonials section styles end

//Payment section styles
export const PaymentSectionWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  margin-bottom: 50px;
  @media (max-width: ${screenSizes.S}px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
export const ConnectWalletDiv = styled.div`
  h4 {
    font-size: 36px;
    color: #1e440b;
    margin-bottom: 20px;
  }
`;
export const TransactionDetailsDiv = styled.div`
  h4 {
    font-size: 36px;
    color: #1e440b;
    margin-bottom: 20px;
  }
`;
export const WalletBox = styled.div`
  border: 1px solid #eaeaea;
  border-radius: 10px;
  padding: 20px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: ${screenSizes.S}px) {
    grid-template-columns: repeat(1, 1fr);
  }
  gap: 14px;
`;
export const TransactionBox = styled.div`
  border: 1px solid #eaeaea;
  border-radius: 10px;
  padding: 20px;
`;
export const Wallet = styled.div`
  border: 1px solid #eaeaea;
  padding: 20px;
  text-align: center;
  img {
    width: 100%;
    max-width: 80px;
  }
  p {
    margin-bottom: 0;
  }
`;
export const InvoiceUl = styled.ul`
  list-style: none;
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #e6e6e6;
  margin: 0;
  &:last-child {
    border-bottom: none;
  }
`;
export const InvoiceLi = styled.li`
  margin: 5px 0;
`;

export const TestAttachImg = styled.img`
width: 25% !important;
`;

export const TestAttachImg4 = styled.img`
width: 40% !important;
`;
//Payment section styles end
